import { render, staticRenderFns } from "./QuoteReviewingTariffSurchargeCard.vue?vue&type=template&id=69f31d3f&"
import script from "./QuoteReviewingTariffSurchargeCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteReviewingTariffSurchargeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports